import { render } from "./NotFound.vue?vue&type=template&id=703fa1d2"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/views/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "703fa1d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('703fa1d2', __exports__)) {
    api.reload('703fa1d2', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=703fa1d2", () => {
    api.rerender('703fa1d2', render)
  })

}


export default __exports__